'use strict';

var Joi = require('joi');
var authMethods = require('../utils/authMethods.js');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var Joi__default = /*#__PURE__*/_interopDefault(Joi);

var _Joi$string;
var LandingPageAccountSubmit = Joi__default["default"].object().keys({
  form_id: Joi__default["default"].string().guid({
    version: ['uuidv4']
  }).allow(null).description('The id of the landing page in Hype Forms table'),
  end_user_email: Joi__default["default"].string().email({
    tlds: {
      allow: false
    }
  }).allow(null).description('End user email if they authed with email'),
  end_user_phone: Joi__default["default"].string().allow(null).description('End user phone number if they authed with SMS'),
  sign_up_method: (_Joi$string = Joi__default["default"].string()).valid.apply(_Joi$string, authMethods).required().description('Auth method used for account')
}).description('landing_page:account_submit event attributes ').meta({
  name: 'LandingPageAccountSubmit',
  filename: 'landing_page:account_submit.model'
});
var LandingPageAccountSubmit$1 = LandingPageAccountSubmit;

module.exports = LandingPageAccountSubmit$1;
//# sourceMappingURL=account_submit.model.js.map
